import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useStyles } from '../styles/ModalLogAcessoStyles';
import { TableColumn } from 'types/table/TableColumn';
import { Tabela } from 'shared/components/table/Tabela';
import { LinhaTabela } from 'shared/components/table/LinhaTabela';
import CustomModal from 'shared/components/modal/CustomModal';
import { RegistroTabela } from 'shared/components/table/RegistroTabela';
import { useGetConfiguracaoEmail } from 'hooks/groupPay/useGetConfiguracaoEmail';
import { useGetLogsDeAcesso } from 'hooks/groupPay/useGetLogsDeAcesso';
import { EnumTipoConfiguracaoEmail } from 'constants/EnumTipoConfiguracaoEmail';

interface ModalLogAcessoProps {
  showModal: boolean;
  onCloseModal: () => void;
  email: string;
}

const colunas: TableColumn[] = [
  {
    id: 'dataHorario',
    label: 'Data e horário'
  }
];

const ModalLogAcesso: React.FC<ModalLogAcessoProps> = ({ showModal, onCloseModal, email }) => {
  const classes = useStyles();
  const { data: configuracaoData } = useGetConfiguracaoEmail();
  
  const isAcessoDiretoCaixa = configuracaoData?.payload?.tipoConfiguracaoEmail === EnumTipoConfiguracaoEmail.ACESSO_DIRETO_CAIXA;
  const { data: logsDeAcesso, isLoading: isLoadingLogs } = useGetLogsDeAcesso(isAcessoDiretoCaixa ? email : "");

  useEffect(() => {
    if (showModal && !isAcessoDiretoCaixa) {
      onCloseModal();
    }
  }, [showModal, isAcessoDiretoCaixa, onCloseModal]);

  const renderEmail = () => {
    return email || 'E-mail não configurado.';
  };
  
  if (!isAcessoDiretoCaixa) {
    return null;
  }

  const conteudoModal = (
    <Box>
      <p className={classes.descricao}>
        Esses logs mostram todas as vezes em que o Group Pay acessou a caixa de entrada para buscar automaticamente as notas fiscais.
      </p>
      <p className={classes.exibicaoEmail}>
        E-mail: {renderEmail()}
      </p>

      <Tabela
        id="tabela-logs-acesso"
        colunas={colunas}
        renderCheckBox={false}
        onChangePageFunction={() => { }}
        paginaAtual={0}
        quantidadeDePaginas={0}
        quantidadeDeRegistros={logsDeAcesso?.length ?? 0}
        isLoading={isLoadingLogs}
        renderPagination={false}
      >
        {logsDeAcesso?.map((logEntry, index) => (
          <LinhaTabela key={index} id={`log-${index}`}>
            <RegistroTabela id={`log-data-${index}`}>
              {logEntry}
            </RegistroTabela>
          </LinhaTabela>
        ))}
      </Tabela>
    </Box>
  );

  return (
    <CustomModal
      tipoModal='MODAL_LATERAL'
      onCloseModal={onCloseModal}
      showModal={showModal}
      size='sm'
      titulo='Log de acesso ao e-mail'
      scrollable
      fecharModalAoClicarFora
    >
      {conteudoModal}
    </CustomModal>
  );
};

export default ModalLogAcesso;